import { Formik, Form, Field } from "formik";
import { Select, MenuItem } from "@mui/material";
import { Search } from "@mui/icons-material";
import tw from "tailwind-styled-components";
import { FieldWrappers, Label } from "../Styles/InputStyles";
import { getUserType } from "../../helpers";
import ListSubheader from "@mui/material/ListSubheader";
import { GrPowerReset } from "react-icons/gr";

const FilterScreen = ({ vendors, onFilterChange, onResetFilters, filtersApplied }) => {

    const initialValues = {
        assetName: "",
        vendorId: "",
        status: "",
        category: "",
    };

    const status = [
        { label: "Active", value: 1 },
        { label: "In Maintenance", value: 2 },
        { label: "Disposed", value: 3 },
        { label: "In Use", value: 4 },
        { label: "Unassigned", value: 5 },
    ];

    const categories = [
        { label: "Furniture & Fixtures", value: 1 },
        { label: "Electrical & Appliances", value: 2 },
        { label: "Plumbing & Sanitary", value: 3 },
        { label: "Security & Access Control", value: 4 },
        { label: "HVAC (Heating, Ventilation & Air Conditioning)", value: 5 },
        { label: "Outdoor & Common Area Assets", value: 6 },
        { label: "IT & Networking Equipment", value: 7 },
        { label: "Kitchen Equipment & Accessories", value: 8 },
        { label: "Miscellaneous Assets", value: 9 },
    ];

    const userTypeVendors = vendors?.filter((v) => v?.userType === 4) || [];

    const handleStatusChange = (e, setFieldValue) => {
        const value = e.target.value;
        setFieldValue('category', '');
        setFieldValue('vendorId', '');
        setFieldValue('assetName', '');
        setFieldValue('status', value);

        if (value) {
            onFilterChange({ filter: 'status', filterVal: value });
        }
        else {
            onFilterChange(null);
        }
    };

    const handleCategoryChange = (e, setFieldValue) => {
        const value = e.target.value;
        setFieldValue('status', '');
        setFieldValue('vendorId', '');
        setFieldValue('assetName', '');
        setFieldValue('category', value);

        if (value) {
            onFilterChange({ filter: 'category', filterVal: value });
        }
        else {
            onFilterChange(null);
        }
    };

    const handleVendorChange = (e, setFieldValue) => {
        const value = e.target.value;
        setFieldValue('status', '');
        setFieldValue('category', '');
        setFieldValue('assetName', '');
        setFieldValue('vendorId', value);

        if (value) {
            onFilterChange({ filter: 'vendorId', filterVal: value });
        }
        else {
            onFilterChange(null);
        }
    };

    const handleApplyFilter = (values, { setSubmitting, setFieldValue }) => {

        if (values.assetName) {
            setFieldValue('status', '');
            setFieldValue('category', '');
            setFieldValue('vendorId', '');
            onFilterChange({ filter: 'assetName', filterVal: values.assetName });
        }
        setSubmitting(false);
    };
    const handleReset = (resetForm) => {
        if (filtersApplied) {
            resetForm();
            onResetFilters();
        }
    };

    return (
        <Container>
            <Formik
                initialValues={initialValues}
                onSubmit={handleApplyFilter}
            >
                {({ values, setFieldValue, isSubmitting, resetForm }) => (
                    <Form>
                        <div className="flex flex-wrap items-center gap-y-2 md:gap-y-4 gap-x-4">
                            <Section>
                                <Label>Category</Label>
                                <Select
                                    name="category"
                                    value={values.category}
                                    onChange={(e) => handleCategoryChange(e, setFieldValue)}
                                    displayEmpty
                                    className="w-full pl-2"
                                    style={{ height: "46px" }}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return <span className="text-gray-400">Select Category</span>;
                                        }
                                        return categories.find((item) => item.value === selected)?.label;
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        Select Category
                                    </MenuItem>
                                    {categories.map((item) => (
                                        <MenuItem key={item.value} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Section>

                            <Section>
                                <Label>Vendors</Label>
                                <Select
                                    name="vendorId"
                                    value={values.vendorId}
                                    onChange={(e) => handleVendorChange(e, setFieldValue)}
                                    displayEmpty
                                    className="w-full pl-2"
                                    style={{ height: "46px" }}
                                    renderValue={(selected) => {
                                        if (!selected) return <span className="text-gray-400">Select Vendor</span>;;
                                        const selectedVendor = vendors?.find(v => v.id === selected);
                                        return selectedVendor ? selectedVendor.name : "";
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        Select Vendor
                                    </MenuItem>

                                    {userTypeVendors.map((item) => (
                                        <MenuItem key={item.id} value={item.id} className="hover:bg-gray-50">
                                            <div className="flex items-center space-x-3">
                                                <div
                                                    className="w-10 h-10 rounded-full flex items-center justify-center"
                                                    style={{ backgroundColor: `#${Math.floor(Math.random() * 16777215).toString(16)}` }}
                                                >
                                                    <span className="text-white text-sm font-semibold">{item.name[0]}</span>
                                                </div>
                                                <div>
                                                    <span className="text-gray-600 text-md font-medium">{item.name}</span>
                                                    <span className="block text-primary-color text-sm">{getUserType(item.userType || 0)}</span>
                                                </div>
                                            </div>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Section>

                            <Section>
                                <Label>Status</Label>
                                <Select
                                    name="status"
                                    value={values.status}
                                    onChange={(e) => handleStatusChange(e, setFieldValue)}
                                    displayEmpty
                                    className="w-full pl-2"
                                    style={{ height: "46px" }}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return <span className="text-gray-400">Select Status</span>;
                                        }
                                        return status.find((item) => item.value === selected)?.label;
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        Select Status
                                    </MenuItem>
                                    {status.map((item) => (
                                        <MenuItem key={item.value} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Section>

                            <Section>
                                <Label>Asset Name</Label>
                                <FieldWrappers className="rounded">
                                    <Search
                                        className="text-gray-400 mr-1"
                                        style={{ fontSize: 18 }}
                                    />
                                    <Field name="assetName" as={Input} placeholder="Search" />
                                </FieldWrappers>
                            </Section>

                            <div className="flex items-end mt-4 md:mt-7 gap-4">
                                <ApplyBtn type="submit" disabled={isSubmitting}>
                                    Apply Filter
                                </ApplyBtn>
                                <ResetBtn
                                    type="button"
                                    title="Clear Filter"
                                    disabled={!filtersApplied}
                                    className={!filtersApplied ? "opacity-50 cursor-not-allowed bg-gray-50 text-gray-500" : ""}
                                    onClick={() => handleReset(resetForm)}
                                >
                                    <GrPowerReset size={20} />
                                </ResetBtn>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </Container>
    );
};

const Container = tw.div`w-full max-w-6xl mx-auto px-4`;
const Section = tw.div`flex-1 md:min-w-[100px] min-w-[150px] space-y-1`;
const Input = tw.input`outline-none text-sm w-full`;
const ApplyBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color h-full rounded px-6  cursor-pointer bg-white hover:bg-hover-color  py-2.5 text-sm`;
const ResetBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-primary-color h-full rounded-md px-3 cursor-pointer bg-gray-100 py-2.5 text-sm`;
export default FilterScreen;
